function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.005,2.005a10,10,0,1,0,10,10A9.99086,9.99086,0,0,0,12.005,2.005Zm3.5,7.84h-1v-.54a2.376,2.376,0,0,0-2.5-2.21,2.376,2.376,0,0,0-2.5,2.21c0,.80005.28,1.79,2.58,2.21,2.82.5,3.42,2.01,3.42,3.18017a3.28423,3.28423,0,0,1-3,3.15992v1.39h-1v-1.39a3.28424,3.28424,0,0,1-3-3.15992v-.5h1v.5a2.376,2.376,0,0,0,2.5,2.21,2.376,2.376,0,0,0,2.5-2.21c0-.75-.28-1.79-2.6-2.20007-2.26-.4-3.4-1.4801-3.4-3.19006a3.28424,3.28424,0,0,1,3-3.15992V4.7649h1V6.145a3.28423,3.28423,0,0,1,3,3.15992Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_13818",
  "data-name": "Trazado 13818",
  className: "cls-1",
  d: "M0,0H24V24H0Z"
});

var SvgSales = function SvgSales(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSales, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sales.8462bffe.svg";
export { ForwardRef as ReactComponent };